import React, { useEffect, useState } from "react";
import { useForm } from "../../../Hooks/UseForm";
import ButtonGeneric from "../../../components/Buttons/ButtonGeneric";
import InputGeneric from "../../../components/Inputs/InputGeneric";
import { Link, useLocation } from "react-router-dom";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import bills from "../../../assets/png/bill.png";
import Modal from "../../../components/Modals/Modal";
import { PaperClipIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../Global/Context/appContext";
import moment from "moment";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import { colors } from "../../../propsType/Colors";
import { InformationCircleIcon } from "@heroicons/react/outline";
import ConsumoController from "../../../controllers/ConsumoController";
import PagosController from "../../../controllers/PagosController";
import AuthController from "../../../controllers/AuthController";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/outline";
import ReactDOM from "react-dom";
import SelectGeneric from "../../../components/Inputs/SelectGeneric";
import { validateNotificacionesCorpo } from "../../../validations/formValidations";
import {
  optionCorporativo, optionPhoneCorporativo, optionBancoBs, optionBancoDivisas,
  optionCtaBanesco, optionCtaProvincial, optionCtaMoneda, optionCtaBancaribe, optionCtaMercantil, optionCtaBNC,
  optionDefault, optionCtaBanescoPanama, optionCtaMercantilPanama, optionCtaBancaribeUSD, optionCtaProvincialUSD,
  optionCtaBanescoUSD, optionCtaMiBancoUSD, optionCtaMercantilUSD, optionDefaultBanco, optionRetencion, optionCtaBanescoUSA, formNotificacionesCorpo
} from "../../../propsType/Corporativo";


function Retenciones({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) {
  const [activeModal, setActiveModal] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [check, setCheck] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [imgModal, setImgModal] = useState(null);
  const [icon, setIcon] = useState(false);
  const [dataBills, setDataBills] = useState([""]);
  const [client, setClient] = useState("");
  const [clientRetenciones, setClientRetenciones] = useState("");
  const [{ user }] = UseContextApp();
  const [emailCliente, setEmailCliente] = useState(user?.datos?.email);
  const location = useLocation();
  const pathName = location.pathname;
  const { ctaFacturaCorpo } = ConsumoController();
  const { notificacionesCorporativo } = PagosController();
  const [checked, setChecked] = useState([]);
  const [checkList, setCheckList] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [IsSelected, setIsSelected] = useState();
  const [isCheckedIVA, setIsCheckedIVA] = useState(false);
  const [isCheckedISLR, setIsCheckedISLR] = useState(false);
  const [isCheckedTimbreFiscal, setIsCheckedTimbreFiscal] = useState(false);
  const [isCheckedCMunicipal, setIsCheckedCMunicipal] = useState(false);
  const [checkedItemsCta, setCheckedItemsCta] = useState("false");
  const [base64IVA, setBase64IVA] = useState("false");
  const [base64ISLR, setBase64ISLR] = useState("false");
  const [base64TimbFiscal, setBase64TimbFiscal] = useState("false");
  const [base64CompMunicipal, setBase64CompMunicipal] = useState("false");
  const handleOnChangeIVA = () => { setIsCheckedIVA(!isCheckedIVA); };
  const handleOnChangeISLR = () => { setIsCheckedISLR(!isCheckedISLR); };
  const handleOnChangeTimbreFiscal = () => { setIsCheckedTimbreFiscal(!isCheckedTimbreFiscal); };
  const handleOnChangeCMunicipal = () => { setIsCheckedCMunicipal(!isCheckedCMunicipal); };
  const [dataCorpo, setDataCorpo] = useState("");
  const { verifyDoc } = AuthController()

  const getCtaCorpo = async () => {
    setLoading(true);
    if ((user.datos === null) || (user.datos === undefined)) {
      const resUser = await verifyDoc(user);
      if (resUser) { user.datos = resUser }
    }
    const res = await ctaFacturaCorpo(user);
    if (res) {
      setDataBills(res);
      setCheckList(res.lCuentasCorpo);
      setLoading(false);
    }

  };

  const handleCheck = (event) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const errorRCJ = (errorType) => {
    setCheck(false);
    setLoading(false);
    setActiveModal(true);

    switch (errorType) {
      case "Archivo":
        setMessage("Recuerda adjuntar el comprobante en formato imagen *.JPG, *. PNG, Excel, Word o en PDF.");
        break;
      case "FileSize":
        setMessage("El tamaño del archivo que estás adjuntando supera los 5MB.");
        break;
      case "Impuesto":
        setMessage("Adjunta archivo del comprobante de impuesto seleccionado.");
        break;
      case "Monto":
        setMessage("Ingresa el monto del impuesto que seleccionaste.");
        break;
      case "ImpuestoTodos":
        setMessage("Recuerda seleccionar el impuesto, ingresar el monto y adjuntar el comprobante que deseas notificar.");
        break;
      case "Correo":
        setMessage("Ingresa el correo electrónico del cliente.");
        break;
      case "Cuenta":
        setMessage("Debes seleccionar Nro(s) documento pendientes por cuenta(s).");
        break;
      case "Telefono":
        setMessage("Ingresa el número de teléfono del cliente.");
        break;
      case "Operacion":
        setMessage("Selecciona la operación que deseas realizar; Pago y/o Retención.");
        break;
      case "pMoneda":
        setMessage("Selecciona la moneda en la que realizaste el pago.");
        break;
      case "pBancoReceptor":
        setMessage("Selecciona el banco receptor del pago.");
        break;
      case "pCuenta":
        setMessage("Selecciona el nro. de cuenta bancaria donde realizaste el pago.");
        break;
      case "pFecha":
        setMessage("Ingresa la fecha del pago.");
        break;
      case "pReferencia":
        setMessage("Ingresa el nro. de referencia del pago.");
        break;
      case "pMonto":
        setMessage("Ingresa el monto del pago.");
        break;
      case "pRetenciones":
        setMessage("Selecciona si el pago que deseas notificar tiene Retenciones.");
        break;
    };
  };



  const convertirBase64IVA = (files) => {
    Array.from(files).forEach(file => {
      let filesize = 0;
      filesize = (file.size / 1000000);
      if ((file.type === "image/jpeg" || file.type === "image/png" ||
        file.type === "application/pdf" || file.type === "application/msword" ||
        file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (filesize < 5)) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var arraySplit = [];
          var base64 = reader.result;
          arraySplit = base64.split(',')
          setBase64IVA(file.name + "|" + arraySplit[1]);
        }
      } else if (filesize > 5) { errorRCJ("FileSize"); }
      else { errorRCJ("Archivo"); }
    })
  
  }

  const convertirBase64ISLR = (files) => {
    Array.from(files).forEach(file => {
      let filesize = 0;
      filesize = (file.size / 1000000);
      if ((file.type === "image/jpeg" || file.type === "image/png" ||
        file.type === "application/pdf" || file.type === "application/msword" ||
        file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (filesize < 5)) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var arraySplit = [];
          var base64 = reader.result;
          arraySplit = base64.split(',')
          setBase64ISLR(file.name + "|" + arraySplit[1]);
        }
      } else if (filesize > 5) { errorRCJ("FileSize"); }
      else { errorRCJ("Archivo"); }
    })
  };

  const convertirBase64TimFiscal = (files) => {
    Array.from(files).forEach(file => {
      let filesize = 0;
      filesize = (file.size / 1000000);
      if ((file.type === "image/jpeg" || file.type === "image/png" ||
        file.type === "application/pdf" || file.type === "application/msword" ||
        file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (filesize < 5)) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var arraySplit = [];
          var base64 = reader.result;
          arraySplit = base64.split(',')
          setBase64TimbFiscal(file.name + "|" + arraySplit[1]);
        }
      } else if (filesize > 5) { errorRCJ("FileSize"); }
      else { errorRCJ("Archivo"); }
    })
  };

  const convertirBase64CompMunicipal = (files) => {
    Array.from(files).forEach(file => {
      let filesize = 0;
      filesize = (file.size / 1000000);
      if ((file.type === "image/jpeg" || file.type === "image/png" ||
        file.type === "application/pdf" || file.type === "application/msword" ||
        file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (filesize < 5)) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var arraySplit = [];
          var base64 = reader.result;
          arraySplit = base64.split(',')
          setBase64CompMunicipal(file.name + "|" + arraySplit[1]);
        }
      } else if (filesize > 5) { errorRCJ("FileSize"); }
      else { errorRCJ("Archivo"); }
    })
  };

  const checkedItems =
    checked.length ?
      checked.reduce(
        (total, item) => {
          return total + "," + item;

        }) : "";

  var isChecked = (item) => checked.includes(item) ? "checked-item" : "not-checked-item";
  const {
    form,
    errors,
    setForm,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm(
    formNotificacionesCorpo,
    validateNotificacionesCorpo,
    emailCliente
  );

  const closetModal = () => {
    setChecked ([]);
    form.cuentasSelect = "";
    setActiveModal(false);
    setMessage("");
    if (activeButton) {
      setErrors('')
    }
  };

  const volver = async () => { window.location.href = '/cuenta'; };
  const handle = (e) => { setClient(e); };
  const handleRetenciones = (e) => { setClientRetenciones(e); };

  const enviarNotificacion = async () => {
    //Validar Campos
    let bError = "false"; let checkimpuesto = "false";
    if ((emailCliente === "") && (emailCliente === undefined) && (form.email === "")) { errorRCJ("Correo"); bError = "true"; }
    else if (form.phone === "" || form.phone.toString().length < 7) { errorRCJ("Telefono"); bError = "true"; }
    else if (checkedItems === "") { errorRCJ("Cuenta"); bError = "true"; }
    else if (client?.name === undefined) { errorRCJ("Operacion"); bError = "true"; }
    else if (client?.name === "Retención") {
      if ((isCheckedIVA === false) && (isCheckedISLR === false) && (isCheckedTimbreFiscal === false) && (isCheckedCMunicipal === false)) { errorRCJ("ImpuestoTodos"); checkimpuesto = "true"; }
      if (isCheckedIVA === true) {
        if (form.montoIVA === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
        else if (base64IVA === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }
      }
      if (isCheckedISLR === true) {
        if (form.montoISLR === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
        else if (base64ISLR === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }

      }
      if (isCheckedTimbreFiscal === true) {
        if (form.montoTimbreFiscal === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
        else if (base64TimbFiscal === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }

      }
      if (isCheckedCMunicipal === true) {
        if (form.montoCompMunicipal === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
        else if (base64CompMunicipal === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }

      }
    }
    else if (client?.name === "Pago") {
      //Valido campos del pago
      if (form.tipoMoneda === "" || form.tipoMoneda === "Seleccione") { errorRCJ("pMoneda"); bError = "true"; }
      else if (form.bancoReceptor === "" || form.bancoReceptor === "Seleccione") { errorRCJ("pBancoReceptor"); bError = "true"; }
      else if (form.cuentaReceptor === "" || form.cuentaReceptor === "Seleccione") { errorRCJ("pCuenta"); bError = "true"; }
      else if (form.date === "") { errorRCJ("pFecha"); bError = "true"; }
      else if (form.numberReference === "") { errorRCJ("pReferencia"); bError = "true"; }
      else if (form.monto === "") { errorRCJ("pMonto"); bError = "true"; }
      else if (form.monto === "0") { errorRCJ("pMonto"); bError = "true"; }
      else if (clientRetenciones?.name === undefined) { errorRCJ("pRetenciones"); bError = "true"; }
      else if (clientRetenciones?.name === "Sí") {
        if ((isCheckedIVA === false) && (isCheckedISLR === false) && (isCheckedTimbreFiscal === false) && (isCheckedCMunicipal === false)) { errorRCJ("ImpuestoTodos"); checkimpuesto = "true"; }
        if (isCheckedIVA === true) {
          if (form.montoIVA === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
          else if (base64IVA === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }
        }
        if (isCheckedISLR === true) {
          if (form.montoISLR === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
          else if (base64ISLR === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }
        }
        if (isCheckedTimbreFiscal === true) {
          if (form.montoTimbreFiscal === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
          else if (base64TimbFiscal === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }
        }
        if (isCheckedCMunicipal === true) {
          if (form.montoCompMunicipal === "") { errorRCJ("Monto"); checkimpuesto = "true"; }
          else if (base64CompMunicipal === "false") { errorRCJ("Impuesto"); checkimpuesto = "true"; }
        }
      }
    }
    if (checkimpuesto === "false" && bError === "false") {
      var arraySplitCuenta = [];
      arraySplitCuenta = checkedItems.split(',');
      let rowCuenta = "";
      let rowFactura = "";
      let nroCuenta = "";
      nroCuenta = arraySplitCuenta[0].split('.')[0].split(':')[1].trim()
      for (let i = 0; i < arraySplitCuenta.length; i++) {
        if (rowCuenta === "") { rowCuenta = arraySplitCuenta[i].split('.')[0].split(':')[1].trim(); }
        else { rowCuenta = rowCuenta + "," + arraySplitCuenta[i].split('.')[0].split(':')[1].trim(); }
        if (rowFactura === "") { rowFactura = arraySplitCuenta[i].split('.')[1].split(':')[1].trim(); }
        else { rowFactura = rowFactura + "," + arraySplitCuenta[i].split('.')[1].split(':')[1].trim(); }
      }
      form.cuentasSelect = checkedItems;
      form.chkIVA = isCheckedIVA;
      form.chkISLR = isCheckedISLR;
      form.chkTimbreFiscal = isCheckedTimbreFiscal;
      form.chkCompMunicipal = isCheckedCMunicipal;
      form.tipoNotificacion = client?.name;
      form.isRetencion = clientRetenciones?.name;
      form.fileIVA = base64IVA;
      form.fileISLR = base64ISLR;
      form.fileTF = base64TimbFiscal;
      form.fileMunicipal = base64CompMunicipal;
      const result = handleSubmit();
      if ((result === "ok")) {
        let newObjet = {
          ciudad: user?.datos?.ciudad,
          nombre: user?.datos?.nombreApellido,
          docIdentidad: user?.datos?.docIdentificacion,
          email: emailCliente,
          tlfContacto: form.selectNumber + form.phone,
          cuentaAbonado: nroCuenta,
          nroCuentas: rowCuenta,
          nroFacturas: rowFactura,
          tipoNotificacion: client?.name,
          tipoCuentaMoneda: form.tipoMoneda,
          bancoReceptor: form.bancoReceptor,
          nroCuentaReceptor: form.cuentaReceptor,
          fechaPago: form.date,
          nroReferencia: form.numberReference,
          montoPago: form.monto,
          montoIVA: form.montoIVA,
          montoISLR: form.montoISLR,
          montoTimbreFiscal: form.montoTimbreFiscal,
          montoCompMunicipal: form.montoCompMunicipal,
          fileIVA: base64IVA,
          fileISLR: base64ISLR,
          fileTimbreFiscal: base64TimbFiscal,
          fileCompMunicipal: base64CompMunicipal,
          isRetencion: clientRetenciones?.name,
          isRetencionIVA: isCheckedIVA,
          isRetencionISLR: isCheckedISLR,
          isRetencionTimbre: isCheckedTimbreFiscal,
          isRetencionMunicipal: isCheckedCMunicipal,
        };
        setLoading(true);
        const res = await notificacionesCorporativo(newObjet);
        if (res) {
          switch (res?.status) {
            case "0004":
              setCheck(true);
              setLoading(false);
              setActiveModal(true);
              setMessage("Hemos registrado tu solicitud de notificación de " + client?.name + " con el número: " + res?.ticketNumber);
              break;
            case "0038":
              setCheck(false);
              setLoading(false);
              setActiveModal(true);
              setMessage("Esta notificación de " + client?.name + " ya se encuentra registrada bajo el número: " + res?.ticketNumber);
              break;
            default:
              setCheck(false);
              setLoading(false);
              setActiveModal(true);
              setMessage("Por favor intenta nuevamente tu notificación más tarde.");
              break;
          }
        }
      };
    };
  };

  const validateData = (banco, moneda) => {
    if (moneda === "Bolívares") {
      switch (banco) {
        case "Bancaribe C.A.": return optionCtaBancaribe;
        case "Banco Mercantil C.A": return optionCtaMercantil;
        case "Banco Provincial S.A.": return optionCtaProvincial;
        case "Banesco S.A.C.A.": return optionCtaBanesco;
        case "Banco Nacional de Crédito C.A.": return optionCtaBNC;
        default: return optionDefault;
      }
    }
    else {
      switch (banco) {
        case "Bancaribe C.A.": return optionCtaBancaribeUSD;
        case "Banco Mercantil C.A": return optionCtaMercantilUSD;
        case "Banco Provincial S.A.": return optionCtaProvincialUSD;
        case "Banesco S.A.C.A.": return optionCtaBanescoUSD;
        case "Mi Banco C.A.": return optionCtaMiBancoUSD;
        case "Banesco Panamá": return optionCtaBanescoPanama;
        case "Banesco USA": return optionCtaBanescoUSA;
        case "Mercantil Panamá": return optionCtaMercantilPanama;
        default: return optionDefault;
      }
    }
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  useEffect(() => {

    getCtaCorpo();
  }, []);

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {loading ?
          (
            <>
              <div className="w-full h-screen flex justify-center items-center ">
                <Spinner title={"Espere..."} />
              </div>
            </>
          ) : (
            <>

              <div className="flex lg:w-full gap-5 px-4  flex-col">
                <BreadCrumbsGeneric locations={pathName} />
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Notifica tus Transferencias, Depósitos o Retenciones
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">Completa la información y haz clic en Notificar </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                    <div className="grid lg:gap-[32px] gap-6 lg:relative lg:top-[10px] ">
                      <div className="flex flex-col lg:grid gap-5  lg:grid-cols-2">
                        <div className="grid">
                          <div className=" flex items-center gap-[3px] text-gray-900">
                            <p className="text-sm font-medium">
                              {" "}
                              Razón Social
                            </p>
                          </div>
                          <div className="col-span-5">
                            <InputGeneric
                              disable={true}
                              placeholder={user?.datos?.nombreApellido}
                              onChange={handleChange}
                              name={"name"}
                              value={form.name}
                              errorText={errors.name}
                              handleBlur={handleBlur}
                            />
                          </div>
                        </div>
                        <InputGeneric
                          title={"Documento de Identidad"}
                          disable={true}
                          placeholder={user?.datos?.docIdentificacion}
                          onChange={handleChange}
                          name={"docIdentidad"}
                          handleBlur={handleBlur}
                          value={form.docIdentidad}
                        />
                      </div>

                      <div className="flex flex-col lg:grid gap-5  lg:grid-cols-2">
                        <InputGeneric
                          title={"Correo Electrónico"}
                          name={"email"}
                          handleBlur={handleBlur}
                          onChange={e => setEmailCliente(e.target.value)}
                          errorText={errors.email}
                          value={emailCliente}
                        />
                        <div className="grid">
                          <div className="flex gap-[3px] items-center text-gray-900">
                            <p className="text-sm font-medium  ">Teléfono de Contacto</p>
                            <p>
                              <div
                                className={` button cursor-pointer !w-[14px]`}
                                data-tooltip={
                                  "Teléfono contacto del cliente."
                                }
                              >
                                <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                              </div>
                            </p>
                          </div>
                          <div className="grid !mt-1  grid-cols-7">
                            <div className="col-span-2">
                              <SelectGeneric
                                onChange={handleChange}
                                value={form.selectNumber || ""}
                                name={"selectNumber"}
                                onBlur={handleBlur}
                                errors={errors.selectNumber}
                                selectData={optionPhoneCorporativo}
                              />
                            </div>
                            <div className="col-span-5">
                              <InputGeneric
                                name={"phone"}
                                type={"number"}
                                value={form.phone}
                                onChange={handleChange}
                                handleBlur={handleBlur}
                                errorText={errors.phone}
                                maxValue={7}
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="flex flex-col lg:grid gap-5">
                        <div className="grid">
                          <div className=" flex items-center gap-[3px] text-gray-900">
                            <p className="text-sm font-medium">
                              Información de Nro(s) Documento pendientes por Cuenta(s).
                            </p>
                          </div>
                          <div className="text-sm font-small">

                            {(checkList != null && checkList.length > 0) ?
                              (checkList.map((item, index) => (
                                <div key={index} >
                                  <input className="text-sm font-small" value={item} type="checkbox" onChange={handleCheck} on />
                                  <span className={isChecked(item)}>{item}</span>
                                </div>
                              ))) : <div></div>}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col lg:grid gap-5 ">
                        <div className="grid">
                          <InputGeneric
                            type={"text"}
                            iconTop={true}
                            textTopTips={
                              "Números de documentos o facturas del cliente notificar transferencia/depósito o retención."
                            }
                            title={"Seleccionaste:👇"}
                            disable={true}
                            onChange={handleChange}
                            name={"cuentasSelect"}
                            handleBlur={handleBlur}
                            // onChange={e => setCheckedItemsCta(checkedItems)}
                            value={checkedItems}
                            errorText={errors.cuentasSelect}
                          />
                        </div>

                      </div>
                      <div className="flex flex-col lg:grid gap-5  lg:grid-cols-2">
                        <div className="grid">
                          <RadioGroup
                            value={client}
                            onChange={(e) => handle(e)}
                            handleBlur={handleBlur}
                            className="w-full"

                          >
                            <RadioGroup.Label className="text-sm font-medium text-gray-900">
                              {" "}
                              Tipo de notificación{" "}
                              <div
                                className={` button cursor-pointer !w-[10px]`}
                                data-tooltip={
                                  "Transferencia o depósito realizado."
                                }
                              >
                                <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                              </div>
                            </RadioGroup.Label>
                            <div className="mt-1 w-full grid grid-cols-1 lg:grid-cols-2 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                              {optionCorporativo.map((ban, index) => (
                                <RadioGroup.Option
                                  key={index}
                                  value={ban}

                                  // disabled = {actPass}
                                  className={({ checked, active }) =>
                                    classNames(
                                      !client
                                        ? "border-red-500"
                                        : "border-gray-300",
                                      active ? "ring-2 ring-[#09101f] " : "holis",
                                      "relative bg-white border rounded-lg h-[40px] p-[9px] shadow-sm  flex cursor-pointer focus:outline-none"
                                    )
                                  }
                                >
                                  {({ checked, active }) => (
                                    <>
                                      <div className="flex-1 flex">
                                        <div className="flex h-[20px] w-full justify-center items-center ">
                                          <RadioGroup.Label
                                            as="span"
                                            className="block text-lg font-medium text-gray-900"
                                          >
                                            {ban.name}
                                          </RadioGroup.Label>
                                        </div>
                                      </div>
                                      {checked ? (
                                        <CheckCircleIcon
                                          className="h-5 w-5 text-[#09101f] "
                                          aria-hidden="true"
                                        />
                                      ) : null}
                                      <div
                                        className={classNames(
                                          active ? "border" : "border-2",
                                          checked
                                            ? "border-[#09101f] "
                                            : "border-transparent",
                                          "absolute -inset-px rounded-lg pointer-events-none"
                                        )}
                                        aria-hidden="true"
                                      />
                                    </>
                                  )}
                                </RadioGroup.Option>
                              ))}
                            </div>
                          </RadioGroup>
                        </div>
                        <div className="grid">
                        </div>
                      </div>
                      <div style={client?.name === "Pago" ? { display: '' } : { display: 'none' }}>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Tipo de Moneda
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Moneda en la que realizaste el pago"
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <SelectGeneric
                              selectData={optionCtaMoneda}
                              name={"tipoMoneda"}
                              onBlur={handleBlur}
                              value={form.tipoMoneda}
                              onChange={handleChange}
                              errors={errors.tipoMoneda}
                            />
                          </div>
                        </div>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Banco Receptor del Pago
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Selecciona el banco donde realizaste el pago"
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <SelectGeneric
                              selectData={form.tipoMoneda === "Bolívares" ? optionBancoBs : optionBancoDivisas}
                              name={"bancoReceptor"}
                              onBlur={handleBlur}
                              value={form.bancoReceptor}
                              onChange={handleChange}
                              errors={errors.bancoReceptor}
                            />
                          </div>
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Nro. de Cuenta
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Selecciona la cuenta donde realizaste el pago"
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <SelectGeneric
                              selectData=
                              {validateData(form.bancoReceptor, form.tipoMoneda)}
                              name={"cuentaReceptor"}
                              onBlur={handleBlur}
                              value={form.cuentaReceptor}
                              onChange={handleChange}
                              errors={errors.cuentaReceptor}

                            />
                          </div>
                        </div>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <InputGeneric
                              type={"date"}
                              textTopTips={"Fecha exacta de realizado el pago"}
                              iconTop={true}
                              maxProps={moment().format("YYYY-MM-DD")}
                              title={"Fecha del Pago"}
                              value={form.date}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"date"}
                              errorText={errors.date}
                            />
                          </div>
                          <div className="w-full space-y-1">
                            <InputGeneric
                              type={"number"}
                              textTopTips={"Número de referencia del pago"}
                              iconTop={true}
                              title={"Número de Referencia"}
                              value={form.numberReference}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"numberReference"}
                              errorText={errors.numberReference}
                            />

                          </div>
                        </div>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <InputGeneric
                              type={"number"}
                              textTopTips={"Monto del pago"}
                              iconTop={true}
                              title={"Monto del Pago"}
                              value={form.monto}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"monto"}
                              errorText={errors.monto}
                            />
                          </div>
                          <div className="w-full space-y-1">

                            <RadioGroup
                              value={clientRetenciones}
                              onChange={(e) => handleRetenciones(e)}
                              className="w-full"
                            >
                              <RadioGroup.Label className="text-sm font-medium text-gray-900">
                                {" "}
                                Retenciones{" "}
                              </RadioGroup.Label>
                              <div className="mt-1 w-full grid grid-cols-1 lg:grid-cols-2 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
                                {optionRetencion.map((ban, index) => (
                                  <RadioGroup.Option
                                    key={index}
                                    value={ban}

                                    // disabled = {actPass}
                                    className={({ checked, active }) =>
                                      classNames(
                                        !clientRetenciones
                                          ? "border-red-500"
                                          : "border-gray-300",
                                        active ? "ring-2 ring-[#09101f] " : "",
                                        "relative bg-white border rounded-lg h-[40px] p-[9px] shadow-sm  flex cursor-pointer focus:outline-none"
                                      )
                                    }
                                  >
                                    {({ checked, active }) => (
                                      <>
                                        <div className="flex-1 flex">
                                          <div className="flex h-[20px] w-full justify-center items-center ">
                                            <RadioGroup.Label
                                              as="span"
                                              className="block text-lg font-medium text-gray-900"

                                            >
                                              {ban.name}
                                            </RadioGroup.Label>
                                          </div>
                                        </div>
                                        {checked ? (
                                          <CheckCircleIcon
                                            className="h-5 w-5 text-[#09101f] "
                                            aria-hidden="true"
                                          />
                                        ) : null}
                                        <div
                                          className={classNames(
                                            active ? "border" : "border-2",
                                            checked
                                              ? "border-[#09101f] "
                                              : "border-transparent",
                                            "absolute -inset-px rounded-lg pointer-events-none"
                                          )}
                                          aria-hidden="true"
                                        />
                                      </>
                                    )}
                                  </RadioGroup.Option>
                                ))}
                              </div>
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                      <div style={(clientRetenciones?.name === "Sí" || client?.name === "Retención") ? { display: '' } : { display: 'none' }}>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <input
                                type={"checkbox"}
                                className="text-sm font-medium"
                                name={"form.chkIVA"}
                                checked={isCheckedIVA}
                                onChange={handleOnChangeIVA}
                                value={form.chkIVA} /><p className="text-sm font-medium">
                                IVA
                              </p>
                            </div>
                            <InputGeneric
                              type={"number"}
                              value={isCheckedIVA ? form.montoIVA : form.montoIVA = ""}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"montoIVA"}
                              errorText={errors.montoIVA}
                              disable={isCheckedIVA ? false : true}
                            />
                          </div>
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Comprobante IVA
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Adjunta el comprobante en formato imagen *.JPG, *.PNG, Excel, Word o en PDF."
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <input
                              type="file"
                              name="fileIVA"
                              multiple onChange={(e) => convertirBase64IVA(e.target.files)}
                              disabled={isCheckedIVA ? false : true}
                            />
                          </div>
                        </div>

                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <input
                                type={"checkbox"}
                                className="text-sm font-medium"
                                name={"chkISLR"}
                                checked={isCheckedISLR}
                                onChange={handleOnChangeISLR}
                                value={form.chkISLR} /><p className="text-sm font-medium">
                                ISLR
                              </p>
                            </div>
                            <InputGeneric
                              type={"number"}
                              value={isCheckedISLR ? form.montoISLR : form.montoISLR = ""}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"montoISLR"}
                              errorText={errors.montoISLR}
                              disable={isCheckedISLR ? false : true}
                            />
                          </div>
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Comprobante ISLR
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Adjunta el comprobante en formato imagen *.JPG, *.PNG, Excel, Word o en PDF."
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <input type="file"
                              name="fileISLR"
                              multiple onChange={(e) => convertirBase64ISLR(e.target.files)}
                              disabled={isCheckedISLR ? false : true}
                            />
                          </div>
                        </div>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <input
                                type={"checkbox"}
                                className="text-sm font-medium"
                                name={"chkTimbreFiscal"}
                                checked={isCheckedTimbreFiscal}
                                onChange={handleOnChangeTimbreFiscal}
                                value={form.chkTimbreFiscal} /><p className="text-sm font-medium">
                                Timbre Fiscal
                              </p>
                            </div>
                            <InputGeneric
                              type={"number"}
                              value={isCheckedTimbreFiscal ? form.montoTimbreFiscal : form.montoTimbreFiscal = ""}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"montoTimbreFiscal"}
                              errorText={errors.montoTimbreFiscal}
                              disable={isCheckedTimbreFiscal ? false : true}
                            />
                          </div>
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Comprobante Timbre Fiscal
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Adjunta el comprobante en formato imagen *.JPG, *.PNG, Excel, Word o en PDF."
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <input type="file"
                              name="fileTF"
                              multiple
                              onChange={(e) => convertirBase64TimFiscal(e.target.files)}
                              disabled={isCheckedTimbreFiscal ? false : true} />
                          </div>
                        </div>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <input
                                type={"checkbox"}
                                className="text-sm font-medium"
                                name={"chkCompMunicipal"}
                                checked={isCheckedCMunicipal}
                                onChange={handleOnChangeCMunicipal}
                                value={form.chkCompMunicipal} /><p className="text-sm font-medium">
                                Comprobante Municipal
                              </p>
                            </div>
                            <InputGeneric
                              type={"number"}
                              value={isCheckedCMunicipal ? form.montoCompMunicipal : form.montoCompMunicipal = ""}
                              onChange={handleChange}
                              handleBlur={handleBlur}
                              name={"montoCompMunicipal"}
                              errorText={errors.montoCompMunicipal}
                              disable={isCheckedCMunicipal ? false : true}
                            />
                          </div>
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Comprobante Municipal
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Adjunta el comprobante en formato imagen *.JPG, *.PNG, Excel, Word o en PDF."
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <input
                              type="file"
                              name="fileMunicipal"
                              multiple onChange={(e) => convertirBase64CompMunicipal(e.target.files)}
                              disabled={isCheckedCMunicipal ? false : true} />
                          </div>
                        </div>


                      </div>
                    </div>
                    <hr className="pt-[10px] mt-[10px]" />
                    <div className="w-full flex justify-between gap-[50%]">
                      <div className="w-full">
                        <ButtonGeneric funtion={volver} text={"Volver"} />
                      </div>
                      <div className="w-full">
                        <ButtonGeneric funtion={enviarNotificacion} text={"Notificar"} />
                      </div>
                    </div>
                    <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                      </div>                 


                  </div>
                </div>
              </div>
            </>
          )}
      </div>

      <Modal
        string={check ? "check" : "error"}
        message={message}
        active={activeModal}
        setActive={setActiveModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <button
              type="button"
              onClick={(e) => check ? volver() : closetModal()}
              className={` ${check ? "bg-green-500" : "bg-red-500"
                } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );

}
export default Retenciones;